<template lang="pug">
GenericCard.user-stat-panel(size='33')
  template(v-if='user')
    div(style='min-height: 360px;')
      .cover-img.d-flex.flex-column.justify-content-end(
        :style='`backgroundImage: url(${coverImg})`'
      )
        .user-name.text-large.pb-2.pr-4
          | {{ user.firstName }}

      .user-img.ml-3
        UserPicture(
          v-if='user.stat'
          :imgSrc='user.imgSrc'
          :badgeNumber='notificationCount'
          @click='showNotifications'
        )
      .user-detail.d-flex
        .id
          | รหัส {{ user.employee_id }}
        .zone.ml-4
          | เขต {{ user.zone }}

      NumberWithDescription.m-3(
        :number='user.performance ? (user.performance.today.sales) : `-`'
        description='ยอดขายวันนี้'
        :large='true'
        :useCurrenyFormat="true"
      )

      hr.m-0

      .goals.px-4.py-3(v-if='user && user.performance')
        .d-flex.justify-content-between.align-items-center
          .text-medium
            | เป้าประจำเดือน
          .text-large.text-blue.font-weight-500
            | {{ user.performance.thisMonth.goal | currency }}
        .progress.mt-3
          .progress-bar(
            :style='`width: ${monthlyPercentage}%`'
            :aria-valuenow='monthlyPercentage' aria-valuemin='0' aria-valuemax='100'
          )
        .d-flex.justify-content-between.mt-1
          .text-turquoise.font-weight-500 {{ user.performance.thisMonth.sales | currency }}
          .text-blue.font-weight-500 {{ user.performance.thisMonth.goal | currency }}

      .blue-gradient.px-4.py-4(v-if='user && user.performance && user.performance.today')
        .d-flex.justify-content-between.align-items-center
          img.img-56(src='@/assets/icons/investment.svg')
          div.d-flex.flex-column.align-items-end
            .text-large.bold.red
              | {{ user.performance.today.commissions | currency }}
            .text-medium ค่าคอมมิชชั่นวันนี้

  template(v-else)
    LoadingError(
      title='เกิดปัญหาในการโหลดสถิติของผู้ใช้'
      @reload='$emit(`reloadAfterError`)'
    )
</template>

<script>
/* eslint-disable global-require */
export default {
  props: {
    user: {},
    notificationCount: {
      default: '...',
    },
  },
  computed: {
    monthlyPercentage() {
      if (this.user && this.user.performance) {
        return this.user.performance.thisMonth.sales / this.user.performance.thisMonth.goal * 100;
      }
      return 0;
    },
  },
  data: () => ({
    coverImg: require('@/assets/dashboard/header-background-user-stat.png'),
  }),
  methods: {
    showNotifications() {
      this.$modal.show('notification');
    },
  },
};
</script>

<style lang="scss" scoped>
$user-img-size: 72px;
$user-img-left-padding: $user-img-size + (16 * 2);

.user-stat-panel {
  position: relative;
  .cover-img {
    height: 80px;
    width: 100%;
    border-top-left-radius: $card-border-radius;
    border-top-right-radius: $card-border-radius;
    .user-name {
      margin-left: $user-img-left-padding;
      color: #fff;
    }
  }
  .user-img {
    height: $user-img-size;
    width: $user-img-size;
    margin-top: -($user-img-size * 0.6);
  }
  .user-detail {
    margin-top: -($user-img-size * 0.4);
    margin-left: $user-img-left-padding;
    font-size: 16px;
    min-height: ($user-img-size * 0.4);
  }
}
</style>
